import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth uses HttpOnly cookies set by the backend on /api/auth/login.
// withCredentials: true ensures axios sends the cookie on every request.
// We deliberately do NOT read or write any token to localStorage — that would
// expose it to XSS. The httpOnly cookie is invisible to JS, which is the point.
const api = axios.create({ baseURL: API, withCredentials: true });

export default api;
